import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, message, Modal, Spin } from 'antd';
import { UserOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { callApi } from '../../../../utils/callApi/rest';
import { getPrimaryColor } from '../../../../utils/getPrimaryColor'
// import { RightGroupManagement, RoleManagement } from '../../components';
import RightGroupManagement from '../../components/RightGroupManagement/index'
import RoleManagement from '../../components/RoleManagement/index'
import { api, rightGroupModalType } from '.././../config';
import { getBasicInfo, filterProject } from '../../utils';
import './index.less';

const prefixCls = 'eh-right-management-group';
class AuthorizeByGroup extends PureComponent {
	state = {
		groupManagementType: false, //显示权限组弹框
		roleModal: false, //角色管理开启状态
		rules: [], //角色授权规则列表
		groupId: undefined, //正在编辑或者查看的groupid
		loading: false,
	};

	basicInfo = {};

	componentDidMount() {
		this.basicInfo = getBasicInfo();
		this.setState({ loading: true }, () => {
			this.listRoleAuthRule();
		});
	}

	/**
	 * 打开权限组对话框
	 * @param {*} type  edit/add/detail
	 */
	openRightGroupManagement = (type, id) => {
		this.setState({
			groupManagementType: type,
			groupId: id
		});
	};

	//查询角色授权规则列表
	listRoleAuthRule = () => {
		callApi({
			api: api.listRoleAuthRule,
			data: {
				...this.basicInfo,
			},
			success: (res) => {
				this.setState({
					rules: res.rules,
					loading: false
				});
			},
			error: (err) => {
				message.error(err.errorDescription || '获取授权规则失败');
			}
		});
	};

	/**
	 * 删除角色授权规则
	 * @param {查询角色授权规则详情} id 角色授权规则ID
	 */
	deleteRoleAuthRule = (id) => {
		const callBack = () => {
			callApi({
				api: api.deleteRoleAuthRule,
				data: {
					...this.basicInfo,
					id
				},
				success: (res) => {
					message.success('删除成功');
					this.listRoleAuthRule();
				},
				error: (err) => {
					message.error(err.errorDescription || '删除失败');
				}
			});
		};

		Modal.confirm({
			title: '确定要删除权限组吗？',
			icon: <ExclamationCircleOutlined />,
			content: '确定要删除权限组吗？',
			okText: '确认',
			cancelText: '取消',
			onOk: callBack
		});
	};

	render() {
		const { groupManagementType, roleModal, rules, groupId, loading } = this.state;
		const { allPrivileges = [], labelGroupId, allProjectList = [], hiddenFilterFlag = 0, showProjectByGroup = true } = this.props;
		const { openRightGroupManagement, deleteRoleAuthRule } = this;
		const titleSpan = '0 0 180px', valueSpan = '0 0 calc( 100% - 180px - 178px )', opBtnSpan = '0 0 178px', gutterStyle = [40, 14];
		return <div className={prefixCls}>
			<Spin spinning={loading}>
				<div className={prefixCls + '-header'}>
					<Button type='primary' onClick={() => { openRightGroupManagement(rightGroupModalType.CREAT); }}>新增权限组</Button>
					<div onClick={e => { this.setState({ roleModal: true }); }}>
						<UserOutlined style={{ color: getPrimaryColor() }} /> 角色管理
					</div>
				</div>
				<div className={prefixCls + '-content'}>
					{
						rules.map((item, index) => {
							const { dataScope } = item;
							//llCommunityScopeFlag === 1 为1 是 选择所有的项目， 为0 是部分，为1 时，communityScope 后台不返回
							const assignedOperations = dataScope.allCommunityScopeFlag === 1 ? allProjectList : filterProject(allProjectList, dataScope.communityScope) || [];
							const assignedOperationsStr = assignedOperations.map(el => el.projectName || '').join('、');
							return (
								<div key={index} className={prefixCls + '-item-wrapper'}>
									<Row gutter={gutterStyle}>
										<Col flex={titleSpan}>
											权限组名称:
										</Col>
										<Col flex={valueSpan}>
											{item.targetName}
										</Col>
										<Col flex={opBtnSpan}>
											<Button size='small' type="link" onClick={e => { openRightGroupManagement(rightGroupModalType.DETAIL, item.id); }} >
												详情
											</Button>
											<Button size='small' type="link" onClick={e => { openRightGroupManagement(rightGroupModalType.EDIT, item.id); }} >
												编辑
											</Button>
											<Button size='small' type="link" onClick={e => { deleteRoleAuthRule(item.id); }} >
												删除
											</Button>
										</Col>
									</Row>
									{
										showProjectByGroup && <Row gutter={gutterStyle}>
											<Col flex={titleSpan}>
												管理项目范围:
											</Col>
											<Col flex={valueSpan}>
												{
													assignedOperationsStr
												}
											</Col>
											<Col flex={opBtnSpan} />
										</Row>
									}
									<Row gutter={gutterStyle}>
										<Col flex={titleSpan}>
											权限组成员数:
										</Col>
										<Col flex={valueSpan}>
											{item.memberSum}
										</Col>
										<Col flex={opBtnSpan} />
									</Row>
								</div>
							);
						})
					}
					{
						!!groupManagementType && <RightGroupManagement
							type={groupManagementType}
							labelGroupId={labelGroupId}
							showProjectByGroup={showProjectByGroup}
							id={groupId}
							allPrivileges={allPrivileges}
							allProjectList={allProjectList}
							hiddenFilterFlag={hiddenFilterFlag}
							onChange={() => {
								this.setState({ groupManagementType: undefined });
								this.listRoleAuthRule();
							}}
						/>
					}
					{
						roleModal && <RoleManagement
							allPrivileges={allPrivileges}
							onChange={() => { this.setState({ roleModal: false }); this.listRoleAuthRule(); }} />
					}
				</div>
			</Spin>
		</div>;
	}
}

export default withRouter(AuthorizeByGroup);
